import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface NewsletterRendererProps {
  data: any;
}

const NewsletterRenderer: React.FC<NewsletterRendererProps> = ({ data }) => {
  if (!data.subject_line) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="text-sm text-gray-500">No newsletter content available</div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 max-w-2xl">
      {/* Email Header Section */}
      <div className="border-b border-gray-200 pb-4 mb-6">
        <div className="text-xs text-gray-500 mb-1">Subject:</div>
        <div className="font-semibold text-lg text-gray-900">{data.subject_line}</div>
        
        {data.preheader && (
          <div className="mt-2">
            <div className="text-xs text-gray-500 mb-1">Preheader:</div>
            <div className="text-sm text-gray-600">{data.preheader}</div>
          </div>
        )}
            </div>

      {/* Email Body - Styled as actual email */}
      <div className="space-y-4 text-gray-800">
        {/* Greeting */}
        <div className="text-sm prose prose-sm max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.greeting}</ReactMarkdown>
        </div>

        {/* Main Content */}
        <div className="text-sm prose prose-sm max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.main_content}</ReactMarkdown>
        </div>

        {/* CTA */}
        <div className="text-sm font-medium prose prose-sm max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.cta}</ReactMarkdown>
        </div>

        {/* Secondary Content (optional) */}
        {data.secondary_content && (
          <div className="text-sm border-t border-gray-100 pt-4 prose prose-sm max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.secondary_content}</ReactMarkdown>
          </div>
        )}

        {/* Closing */}
        <div className="text-sm prose prose-sm max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.closing}</ReactMarkdown>
        </div>

        {/* Footer */}
        <div className="text-xs text-gray-500 border-t border-gray-200 pt-4 mt-6 prose prose-xs max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.footer}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default NewsletterRenderer;
